import type { Address } from '~~/types/commercetools';
import type { AddressType } from '~~/types/AddressType';
import type { ValidationProvider } from '~~/types/vee-validate';
import { CheckoutClientType } from '~~/types/checkout/formData/checkoutClientType';
import { scrollToSection } from '~~/helpers/scroll/scrollToSection';

interface ResetBusinessInfoParams {
  setVatNumber: (param: string) => Promise<void>;
  clientType: CheckoutClientType | null;
  setAddressDetailsMutation: (billingDetails: Partial<Address>) => void
}

interface UseCheckoutAddressParams {
  addressType: AddressType,
  scrollToTopOfForm: string,
  addressDetails: Ref<Partial<Address>>
}

export default (
  {
    addressType,
    scrollToTopOfForm,
    addressDetails,
  }: UseCheckoutAddressParams) => {

  const displayErrorNotification = useState(`displayErrorNotification-${addressType}`, () => false);
  const displayWarningNotification = useState(`displayWarningNotification-${addressType}`, () => false);

  const displayNotification = (isWarning = false, fields?: Record<string, ValidationProvider> | undefined) => {

    displayErrorNotification.value = !isWarning;
    displayWarningNotification.value = isWarning;
    const firstInvalidId = getFirstInvalidField(fields);
    scrollToSection(firstInvalidId || scrollToTopOfForm, -50);
  
  };

  const getFirstInvalidField = (fields: Record<string, ValidationProvider> | undefined): string | undefined => {

    const fieldValues = Object.values(fields || {});
    const firstInvalidField = fieldValues.find(field => field.failed);

    return firstInvalidField ? `#${firstInvalidField.name}` : undefined;
  
  };

  const resetNotifications = () => {

    displayErrorNotification.value = false;
    displayWarningNotification.value = false;
  
  };
  const displayAnyNotification = computed(() =>
    displayErrorNotification.value ||
    displayWarningNotification.value,
  );
  const scrollToField = useState<string>(`scrollToField-${addressType}`, () => '');
  const setScrollToField = (field: string) => {

    scrollToField.value = field;
  
  };

  const removeUnnecessaryAddressProperties = () => {

    delete addressDetails.value.__typename;
    delete addressDetails.value.custom;
  
  };

  const resetBusinessInfoForPrivateCustomer = async ({
    setVatNumber,
    clientType,
    setAddressDetailsMutation,
  }: ResetBusinessInfoParams) => {

    if (clientType === CheckoutClientType.PRIVATE) {

      await setVatNumber('');
      setAddressDetailsMutation({ ...addressDetails.value, company: null, department: null });
    
    }
  
  };

  return {
    displayErrorNotification,
    displayWarningNotification,
    displayAnyNotification,
    displayNotification,
    resetNotifications,
    scrollToField,
    setScrollToField,
    getFirstInvalidField,
    resetBusinessInfoForPrivateCustomer,
    removeUnnecessaryAddressProperties,
  };

};
